
































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import store from '../../../services/store';
import BudgetIntegrationIdcExpenses from "@/modules/budget/integrations/BudgetIntegrationIdcExpenses.vue";
import { loadVariantsWithEndDate, loadUserLevels, loadDataTypeDict } from '@/modules/budget/budgetVariantService';

export default {
    name: 'integration-idc',
    components: { BudgetIntegrationIdcExpenses },
    data() {
        return {
            year: null,
            obl: null, // '45'
            region: null, // '450101',
            variant: null,
            tabIndx: 0,

            listRegs: [],
            currentYear: null,
            listVariants: [],
            dataTypeDict: [],
            userRegion: null,
            limitAccessLevel: 0
        }
    },
    async mounted() {
        // this.year = this.currentYear = (new Date().getFullYear()+1);
    },

    computed: {
        userUiid() {
            return store.state.user.sub;
        },
    },
}
